import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import objectPath from "object-path";
import * as builder from "../../ducks/builder";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
function Footer({ footerClasses, footerContainerClasses }) {
  const { userPreferences, reload } = useGlobalData();
  const [today, setToday] = useState(DateTime.now());

  useEffect(() => {
    setInterval(() => setToday(DateTime.now()), 1000);
    return () => {
      setToday(DateTime.now());
    };
  }, [reload]);

  return (
    <div
      className={`kt-footer ${footerClasses} kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop`}
      id="kt_footer"
      style={{
        //backgroundImage: "linear-gradient(rgb(2, 98, 154) 0px, rgb(7, 134, 188) 59%, rgb(13, 170, 222) 100%)",
        backgroundAttachment: "fixed",
        backgroundImage: `${
          userPreferences.invifoThemeID > 0
            ? `url(${toAbsoluteUrl(
                `/media/bg/${userPreferences.invifoTheme.imageName}`
              )})`
            : userPreferences.customThemeID > 0
            ? "url(" + userPreferences.customTheme.imagePath + ")"
            : `url(${toAbsoluteUrl("/media/bg/bg-aqua.jpg")})`
        }`,
        /*backgroundColor: `${
          userPreferences.lightTheme === true
            ? `#e8ecfa`
            : userPreferences.darkTheme === true
            ? `#1e1e2d`
            : `none`
        }`,*/
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className={`kt-container ${footerContainerClasses}`}>
        <div
          className={`kt-footer__copyright${
            userPreferences.lightText === true ? " text-white" : ""
          }`}
        >
          {today.year}&nbsp;&copy;&nbsp;
          <a
            href="http://invifo.com"
            target="_blank"
            rel="noopener noreferrer"
            className={`kt-link text-hover-primary${
              userPreferences.lightText === true ? " text-white" : ""
            }`}
          >
            Invifo Enterprise
          </a>
          &nbsp;Core Platform
        </div>
        <div
          className={`kt-footer__datetime${
            userPreferences.lightText === true ? " text-white" : ""
          }`}
        >
          <span className="mr-2">
            <i className="far fa-calendar-alt"></i>
          </span>
          <span className="mr-2">{today.toFormat("ccc, dd MMM yyyy")}</span>
          <span className="mr-2">
            <i className="far fa-clock"></i>
          </span>
          <span className="mr-2">{today.toFormat("hh:mm a (ZZZZ)")}</span>
        </div>
        <div className="kt-footer__menu">
          <a
            href="http://invifo.com/about"
            target="_blank"
            rel="noopener noreferrer"
            className={`kt-footer__menu-link kt-link text-hover-primary${
              userPreferences.lightText === true ? " text-white" : ""
            }`}
          >
            About
          </a>
          <Link
            to="/common/legalStatement"
            className={`kt-footer__menu-link kt-link text-hover-primary${
              userPreferences.lightText === true ? " text-white" : ""
            }`}
          >
            Legal Statements
          </Link>
          <a
            href="http://invifo.com/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className={`kt-footer__menu-link kt-link text-hover-primary${
              userPreferences.lightText === true ? " text-white" : ""
            }`}
          >
            Contact
          </a>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (store) => ({
  fluid:
    objectPath.get(store.builder.layoutConfig, "footer.self.width") === "fluid",
  footerClasses: builder.selectors.getClasses(store, {
    path: "footer",
    toString: true,
  }),
  footerContainerClasses: builder.selectors.getClasses(store, {
    path: "footer_container",
    toString: true,
  }),
});

export default connect(mapStateToProps)(Footer);
